import script from "./Lock.vue?vue&type=script&setup=true&lang=js"
export * from "./Lock.vue?vue&type=script&setup=true&lang=js"

import "./Lock.vue?vue&type=style&index=0&id=3baee440&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baee440"]])

export default __exports__